import { createClient } from "@supabase/supabase-js";

// ============================================================
// Supabase Client
// Credentials must be set in .env (never hardcoded in source).
// See .env.example for required variable names.
// ============================================================
const supabaseUrl = (import.meta.env.VITE_SUPABASE_URL as string) || "";
const supabaseAnonKey = (import.meta.env.VITE_SUPABASE_ANON_KEY as string) || "";

/**
 * True when the app is running without real Supabase credentials.
 * The UI uses this flag to show a "Setup Required" screen instead of crashing.
 */
export const isMissingSupabaseConfig = !supabaseUrl || !supabaseAnonKey;

// Supabase's createClient validates that the URL is non-empty at call time.
// When credentials are missing we pass safe placeholder values so the import
// doesn't throw; the app will display the Setup Required screen instead.
const _url = supabaseUrl || "https://placeholder.supabase.co";
const _key = supabaseAnonKey || "placeholder-anon-key";

// No-op lock to prevent NavigatorLockAcquireTimeoutError during dev/HMR
const noopLock = async (_name: string, _acquireTimeout: number, fn: () => Promise<any>) => {
  return await fn();
};

export const supabase = createClient(_url, _key, {
  auth: {
    lock: noopLock as any,
    storageKey: "sb-stratakey-auth-token",
    flowType: "pkce",
    detectSessionInUrl: true,
    persistSession: true,
  },
});
